import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'

interface UpdateNotificationProps {
  organizationUuid: string
  notificationId?: string
}

export async function updateNotificationRead(
  this: ThisConnector,
  { organizationUuid, notificationId }: UpdateNotificationProps
) {
  const url = notificationId
    ? `/${organizationUuid}/notifications`
    : `/${organizationUuid}/notifications/read`
  const body = notificationId ? { notifications: [notificationId] } : undefined
  return this.connector.put<BaseApiResponse>(url, body)
}
